import { Component } from '@angular/core';

@Component({
  selector: 'nav-arrow-left',
  standalone: true,
  imports: [],
  templateUrl: './nav-arrow-left.component.html',
  styleUrl: './nav-arrow-left.component.scss',
})
export class NavArrowLeftComponent {}
